import React from 'react';
import { Navigate } from 'react-router-dom';
import { AuthService } from 'services';
import { CoreRoutes } from 'app-constants';
export const LogOutPage = () => {
	AuthService.logout();
	return <Navigate to={CoreRoutes.login} />;
};